var map = {
	"./AZ.svg": 10267,
	"./EU.svg": 41864,
	"./GB.svg": 45453,
	"./KZ.svg": 73561,
	"./RO.svg": 11215,
	"./RU.svg": 69413,
	"./TR.svg": 95816,
	"./UZ.svg": 94143
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72074;